import { http } from "./http"

import { SupplierGroup, NewSupplier, Suppliers } from "models/suppliergroups"

import { Paginated } from "./types"
import { DocType, Document } from "models/documents"

export const fetchSuppliers = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("supplier-groups", { searchParams }).json()
  return res as Paginated<SupplierGroup>
}

export const createSupplier = async (pld: NewSupplier) => {
  const json = pld
  const res = await http.post("supplier-groups", { json }).json()
  return res as SupplierGroup
}

export const fetchSupplier = async (
  _key: string,
  id: string,
): Promise<SupplierGroup> => await http(`supplier-groups/${id}`).json()

export const patchSupplier = async (pld: Partial<SupplierGroup>) => {
  const { id, ...data } = pld
  const res = await http.patch(`supplier-groups/${id}`, { json: data }).json()
  return res as SupplierGroup
}

export const fetchUnassignedVendors = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  searchParams.set("unassigned", "true")
  const res = await http.get(`suppliers`, { searchParams }).json()
  return res as Paginated<Suppliers>
}

type SupplierPayload = {
  id: string
  supplierIds: Array<string>
}

export const patchUnassignedVendors = async (pld: SupplierPayload) => {
  const { id, supplierIds } = pld
  const res = await http
    .post(`supplier-groups/${id}/suppliers`, { json: { supplierIds } })
    .json()
  return res as Paginated<Suppliers>
}

export const patchAssignedSupplier = async (pld: SupplierPayload) => {
  const { id, ...json } = pld
  return await http.delete(`supplier-groups/${id}/suppliers`, { json })
}

export const fetchSuppliergroupsDocuments = async (
  _key: string,
  id: string,
) => {
  const res = await http(
    `supplier-groups/${id}/documents?sort=DATE_CREATED,DESC`,
  ).json()
  return res as Array<Document>
}

type UploadSuppliergroupsCodPld = {
  file?: File
  mediaType?: string
  description?: string
  ownerEntityId: string
  documentType?: DocType
  tags?: string
}

export const uploadSuppliergroupsDocument = async (
  pld: UploadSuppliergroupsCodPld,
) => {
  if (pld.file === undefined) return
  const { file, ownerEntityId, documentType, description } = pld
  const formData = new FormData()
  formData.append("file", file)
  formData.append("name", file.name)
  if (documentType !== undefined) {
    formData.append("documentType", documentType)
  }
  if (description !== undefined) {
    formData.append("description", description)
  }

  const res = await http
    .post(`supplier-groups/${ownerEntityId}/documents`, {
      body: formData,
      timeout: false,
    })
    .json()
  return res
}

export const deleteSuppliergroupsDocument = async (id: string) => {
  await http.delete(`supplier-groups/documents/${id}`)
}

export const deleteSupplier = async (id: string) =>
  await http.delete(`supplier-groups/${id}`)
